"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG_API_URL = {
    ppe: {
        SSO_CONFIG_URL: '//ssoconfigs.it.beta.sankuai.com',
    },
    test: {
        SSO_CONFIG_URL: '//ssoconfigs.it.test.sankuai.com',
    },
    dev: {
        SSO_CONFIG_URL: '//ssoconfigs.it.dev.sankuai.com',
    },
    product: {
        SSO_CONFIG_URL: 'https://ssosv.sankuai.com/configs',
    },
    staging: {
        SSO_CONFIG_URL: 'https://ssosv.sankuai.com/configs',
    },
};
exports.SSO_SPECIAL_ROUTE = {
    callbackUrl: '/sso/callback',
    logoutUrl: '/sso/logout',
    robotUrl: '/sso/robot',
};
exports.DEFAULT_SSO_ACCESS_CONFIG = {
    dev: {
        accessEnv: 'dev',
        http: {
            openApiHost: '//ssosv.it.test.sankuai.info/open',
            ssoSvHost: '//ssosv.it.test.sankuai.info/sson',
        },
        id: 'dev_master',
        loginUrl: '//ssosv.it.test.sankuai.info/sson/login',
        thrift: {
            openApiThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
                remoteServerPort: 9002,
            },
            ssoSvThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
                remoteServerPort: 9002,
            },
        },
    },
    test: {
        accessEnv: 'test',
        http: {
            openApiHost: '//ssosv.it.test.sankuai.com/open',
            ssoSvHost: '//ssosv.it.test.sankuai.com/sson',
        },
        id: 'test_master',
        loginUrl: '//ssosv.it.test.sankuai.com/sson/login',
        thrift: {
            openApiThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
                remoteServerPort: 9002,
            },
            ssoSvThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
                remoteServerPort: 9002,
            },
        },
    },
    staging: {
        accessEnv: 'staging',
        http: {
            openApiHost: '//ssosv.it.st.sankuai.com/open',
            ssoSvHost: '//ssosv.it.st.sankuai.com/sson',
        },
        id: 'staging_master',
        loginUrl: '//ssosv.it.st.sankuai.com/sson/login',
        thrift: {
            openApiThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
                remoteServerPort: 9002,
            },
            ssoSvThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
                remoteServerPort: 9002,
            },
        },
    },
    ppe: {
        accessEnv: 'ppe',
        http: {
            openApiHost: '//ssosv.it.beta.sankuai.com/open',
            ssoSvHost: '//ssosv.it.beta.sankuai.com/sson',
        },
        id: 'ppe_master',
        loginUrl: '//ssosv.it.beta.sankuai.com/sson/login',
        thrift: {
            openApiThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
                remoteServerPort: 9002,
            },
            ssoSvThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
                remoteServerPort: 9002,
            },
        },
    },
    product: {
        accessEnv: 'product',
        http: {
            openApiHost: 'https://ssosv.sankuai.com/open',
            ssoSvHost: 'https://ssosv.sankuai.com/sson',
        },
        id: 'product_master',
        loginUrl: 'https://ssosv.sankuai.com/sson/login',
        thrift: {
            openApiThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
                remoteServerPort: 9002,
            },
            ssoSvThrift: {
                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
                remoteServerPort: 9002,
            },
        },
    },
};
exports.configMappingModel = {
    loginUrl: {
        layer: 'accessPoint',
    },
    accessEnv: {
        layer: 'accessPoint',
    },
    openApiHost: {
        layer: 'accessPoint.http',
    },
    ssoSvHost: {
        layer: 'accessPoint.http',
    },
};
exports.HARD_CODE_METHOD = 'SHA256';
exports.WEB_DEFAULT_IP = '0.0.0.0';
//# sourceMappingURL=const.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/config/const.js